import { Response } from '@candu-ai/first-mate/api';

export const MODIFY_TEXT_API = '/api/first-mate/modify-text';

export type ModifyTextRequest = {
  prompt: string;
};

export type ModifyTextResponse = Response<string[]>;
